// extracted by mini-css-extract-plugin
export default {"titleInput":"main_titleInput__EsT7Q","spinnerWrapper":"main_spinnerWrapper__jjMRQ"};